export interface CreateAdminProjectPayload {
  id: string;
  ecosystemId: string;
  name: string;
  description?: string;
  openprojectUrl?: string;
  nextcloudUrl?: string;
  giteaUrl?: string;
  includeRepository?: boolean;
}

export async function adminCreateProject(
  token: string,
  payload: CreateAdminProjectPayload
): Promise<{ project: Record<string, unknown> }> {
  const res = await fetch('/api/admin/projects', {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
      flags: { sync: true },
    }),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error((data as { message?: string }).message || `Request failed: ${res.status}`);
  }
  const project = (data as { project?: Record<string, unknown> }).project;
  if (!project) {
    throw new Error('Create succeeded but project payload missing; check portal API response');
  }
  return { project };
}
